module.exports = __webpack_public_path__ + "static/media/warning.ba352a8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning.svg
// module id = 1248
// module chunks = 0